import React from "react";
import PluginsView from "../../components/views/plugins-view/PluginsView";

export default function PluginsPage() {
  return <PluginsView />;
}
